<template>
  <div class="video-catalog-wrap">
    <happy-scroll color="rgba(42,85,218,0.8)" resize hide-horizontal>
      <ul class="video-catalog-list">
        <li
          v-for="(item1, index1) in courseCatalog"
          :key="index1"
          @click="catalogVisible(item1)"
        >
          <p>
            <a href="javascript:;" :title="item1.catName">
              <Icon type="md-arrow-dropdown" v-if="item1.isVisible" />
              <Icon type="md-arrow-dropright" v-else />
              {{ item1.catName }}
            </a>
          </p>
          <ul v-show="item1.isVisible">
            <li
              style="height: 30px"
              v-show="isBuy && page == 'practice'"
              @click.stop
            >
              <p style="font-size: 12px; line-height: 15px; color: #8f9091">
                <span>视频：{{ item1.pptFinishNum }}/{{ item1.pptNum }}</span>
              </p>
            </li>
            <li
              v-for="(item2, index2) in item1.childList"
              :key="index2"
              @click="catalogVisible(item2, item1)"
            >
              <p>
                <a href="javascript:;" :title="item2.catName">
                  <Icon type="md-arrow-dropdown" v-if="item2.isVisible" />
                  <Icon type="md-arrow-dropright" v-else />
                  {{ item2.catName }}
                </a>
              </p>
              <ul v-show="item2.isVisible">
                <li
                  style="height: 30px"
                  v-show="isBuy && page == 'practice'"
                  @click.stop
                >
                  <p style="font-size: 12px; line-height: 15px; color: #8f9091">
                    视频：{{ item2.pptFinishNum }}/{{ item2.pptNum }}
                  </p>
                </li>
                <li
                  v-for="(item3, index3) in item2.childList"
                  :key="index3"
                  @click.stop="changeVideo(item3)"
                  :class="isSelected(item3, item2, item1)"
                >
                  <p>
                    <a href="javascript:;" :title="item3.catName">
                      <Icon
                        custom="ich-icon ich-icon-catalog-play"
                        size="16"
                        v-if="item3.isTryLook"
                      />
                      <Icon
                        custom="ich-icon ich-icon-catalog-lock"
                        size="16"
                        v-else
                      />
                      {{ item3.catName }}
                    </a>
                    <a
                      href="javascript:;"
                      style="color: #3e9cee"
                      @click="lectureShow(item3)"
                      v-show="isBuy && page == 'practice' && item3.lectureNotes"
                      class="lecture-view"
                      >讲义</a
                    >
                    <span
                      class="play-finish"
                      v-show="isBuy && item3.pptFinishFlag"
                    >
                      <Icon
                        type="md-checkmark-circle"
                        size="16"
                        color="#41a5fd"
                      />
                    </span>
                  </p>
                  <Drawer
                    title="讲义"
                    :width="420"
                    :closable="true"
                    :mask="false"
                    :scrollable="true"
                    v-model="item3.lectureVisible"
                  >
                    <div class="lecture-view" v-html="item3.lectureNotes"></div>
                  </Drawer>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </happy-scroll>
  </div>
</template>
<script>
import { siteMixin } from "../../utils/mixin";
import { HappyScroll } from "vue-happy-scroll";
import "vue-happy-scroll/docs/happy-scroll.css";
export default {
  mixins: [siteMixin],
  props: {
    page: {
      type: String,
      default: "default",
    },
  },
  data() {
    return {};
  },
  components: {
    HappyScroll,
  },
  watch: {
    courseCatalog() {
      this.firstLoaded = false;
      this.initPlayList();
    },
  },
  beforeDestroy() {
    this.setCourseCatalog([]);
    this.setPlayList([]);
  },
  mounted() {
    //this.initPlayList();
  },
  methods: {
    initPlayList() {
      if (this.courseCatalog && this.courseCatalog.length > 0) {
        //console.log("ssss", this.courseCatalog);
        let list = [];
        this.courseCatalog.forEach((one) => {
          if (one.childList) {
            one.childList.forEach((two) => {
              if (two.childList) {
                two.childList.forEach((three) => {
                  if (three.isTryLook == 1 && three.bVideoId) {
                    list.push({
                      pptId: three.pptId,
                      videoId: three.bVideoId,
                      catId: three.catId,
                    });
                  }
                });
              }
            });
          }
        });
        this.setPlayList(list);
      }
    },
    changeVideo(item) {
      if (!item.isTryLook) return;
      this.setVideoId(item.bVideoId);
      this.setCatalogId(item.catId);
      this.setPptId(item.pptId);
    },
    isSelected(item, shelf, parent) {
      if (item.bVideoId == this.videoId) {
        if (!this.firstLoaded) {
          this.firstLoaded = true;
          this.setVisible(shelf, true);
          this.setVisible(parent, true);
        }
        return { selected: true };
      } else {
        return { selected: false };
      }
    },
    catalogVisible(shelf, parent) {
      this.setVisible(shelf);
      if (parent) {
        this.setVisible(parent);
      }
    },
    setVisible(item, value) {
      if (typeof item.isVisible == "undefined") {
        if (value) {
          this.$set(item, "isVisible", value);
        } else {
          this.$set(item, "isVisible", true);
        }
      } else {
        item.isVisible = value ? value : !item.isVisible;
      }
    },
    lectureShow(item) {
      if (typeof item.lectureVisible == "undefined") {
        this.$set(item, "lectureVisible", true);
      } else {
        item.lectureVisible = true;
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/var.less";
.video-catalog-wrap {
  height: 470px;
  width: 336px;
  .video-catalog-list {
    width: 336px;
    padding-bottom: 20px;
    li {
      margin: 7px 0;
      line-height: 40px;
      display: block;
      p {
        color: #ccc;
        display: flex;
        align-items: center;
        line-height: 40px;
        padding: 0 10px;
        font-size: 16px;
        overflow: hidden;
        a {
          flex: 1;
          display: block;
          .ellipsis();
          & > i {
            color: #ccc;
            margin-right: 2px;
            font-size: 18px;
          }
          &:first-child {
            color: #ccc;
            font-size: 18px;
          }
          &.lecture-view {
            flex: 0 1 36px;
          }
        }
        .play-finish {
          flex: 0 0 12px;
          width: 12px;
          height: 12px;
          line-height: 1;
          background-color: #ccc;
          border-radius: 10px;
          i {
            display: block;
            margin: -2px;
          }
        }
        &:hover {
          background-color: #292929;
        }
      }
      &.selected {
        background-color: #292929;
      }
    }
    & > li > ul > li > p {
      padding-left: 30px;
      a {
        &:first-child {
          color: #ddd;
          font-size: 16px;
        }
      }
    }

    & > li > ul > li > ul > li > p {
      padding-left: 40px;
    }
    & > li > ul > li > ul > li p a {
      & > i {
        vertical-align: -0.02em;
        color: #999;
      }
      &:first-child {
        color: #999;
        font-size: 14px;
      }
    }

    // & > li > ul > li > ul > li.selected p a:first-child {
    //   color: #999;
    // }
    // & > li > ul > li > ul > li.selected i,
    // & > li > ul > li > ul > li:hover i {
    //   color: #999;
    // }
  }
}
.lecture-view {
  user-select: none;
  img {
    max-width: 100%;
  }
}
</style>